<template>
    <div class="loan-list-container">
        <h2 class="title">Total Audit Loan Account</h2>

        <!-- Filter -->
        <div class="d-flex justify-content-center mb-3 filters">
            <div class="col-md-4">
                <label>Month & Year</label>
                <input type="month" v-model="filters.month_year" @change="onFilterChange" class="form-control" />
            </div>
        </div>

        <!-- Table -->
        <table class="loan-table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Customer Name</th>
                    <th>Account Number</th>
                    <th>Loan Amount</th>
                    <th>Total Received</th>
                    <th>Remaining Amount</th>
                    <th>Last Payment Date</th>
                    <th>Total Paid EMI</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(loan, index) in loans" :key="loan.id">
                    <td>{{ ((pagination.current_page - 1) * pagination.per_page) + (index + 1) }}</td>
                    <td>{{ loan.customer_name ?? '-' }}</td>
                    <td>{{ loan.manualid ?? '-' }}</td>
                    <td>{{ loan.totalloanamount ?? 0 }}</td>
                    <td>{{ parseFloat(loan.totalreceived).toFixed(2) ?? 0 }}</td>
                    <td>{{ parseFloat(loan.remainingamount).toFixed(2) ?? 0 }}</td>
                    <td>{{ loan.lastpaymentdate ?? '-' }}</td>
                    <td>
                        <span :class="loan.totalreceived > loan.total_paid_emi ? 'span-danger' : 'span-success'">{{ loan.total_paid_emi }}</span>
                    </td>
                </tr>
                <tr v-if="!loans.length">
                    <td colspan="6">No records found</td>
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div class="pagination">
            <button :disabled="pagination.current_page === 1" @click="changePage(pagination.current_page - 1)">
                Previous
            </button>
            <span>Page {{ pagination.current_page }} of {{ pagination.last_page }}</span>
            <button :disabled="pagination.current_page === pagination.last_page"
                @click="changePage(pagination.current_page + 1)">
                Next
            </button>
            <p class="m-0">Total Records: {{ pagination.total }}</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loans: [],
            filters: {
                month_year: "",
            },
            pagination: {
                total: 0,
                per_page: 0,
                current_page: 1,
                last_page: 1,
            },
        };
    },
    mounted() {
        this.fetchLoans(1); // Start from page 1
    },
    methods: {
        async fetchLoans(page = 1) {
            try {
                // Default to current month if not selected
                if (!this.filters.month_year) {
                    this.filters.month_year = new Date().toISOString().slice(0, 7);
                }

                const [year, month] = this.filters.month_year.split("-");

                // Send request with pagination
                const response = await axios.post(
                    `api/audit/total-received?page=${page}`,
                    { month, year }
                );

                this.loans = response.data.data;
                this.pagination.total = response.data.total;
                this.pagination.per_page = response.data.per_page;
                this.pagination.current_page = response.data.current_page;
                this.pagination.last_page = response.data.last_page;
            } catch (error) {
                console.error("Error fetching loans:", error);
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pagination.last_page) {
                this.fetchLoans(page);
            }
        },
        onFilterChange() {
            // Reset to page 1 when filters change
            this.pagination.current_page = 1;
            this.fetchLoans(1);
        },
    },
};
</script>

<style scoped>
.loan-list-container {
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.title {
    text-align: center;
    color: #1a237e;
    margin-bottom: 20px;
}

.filters {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 20px;
}

.loan-table {
    width: 100%;
    border-collapse: collapse;
}

.loan-table th,
.loan-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

.loan-table th {
    background-color: #f5f5f5;
}

.pagination {
    margin-top: 15px;
    text-align: center;
}

.pagination button {
    margin: 0 8px;
    padding: 6px 12px;
    border: none;
    background-color: #1976d2;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s;
}
.pagination {
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
    justify-content: end;
    align-items: center;
}

.pagination button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.pagination button:hover:not(:disabled) {
    background-color: #0d47a1;
}
.span-success {
    padding: 3px;
    border: 1px solid green;
    color: green !important;
    background: #00800026;
    border-radius: 5px;
}
.span-danger {
    padding: 3px;
    border: 1px solid red;
    color: red !important;
    background: #ff000026;
    border-radius: 5px;
}
</style>
